import {AbstractControl, FormGroupDirective, NgControl, NgForm} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {Subject} from 'rxjs';

/**
 * Base class for MatFileInputComponent — replaces the removed mixinErrorState mixin
 * (removed in Angular Material 20).
 */
export abstract class MatFileInputMixinBase {
    errorState = false;
    readonly stateChanges: Subject<void>;

    constructor(
        public _defaultErrorStateMatcher: ErrorStateMatcher,
        public _parentForm: NgForm,
        public _parentFormGroup: FormGroupDirective,
        public ngControl: NgControl,
        stateChanges: Subject<void>
    ) {
        this.stateChanges = stateChanges;
    }

    updateErrorState(): void {
        const oldState = this.errorState;
        const parent = this._parentFormGroup || this._parentForm;
        const matcher = (this as { errorStateMatcher?: ErrorStateMatcher }).errorStateMatcher || this._defaultErrorStateMatcher;
        const control = this.ngControl ? (this.ngControl.control as AbstractControl) : null;
        const newState = matcher.isErrorState(control, parent);

        if (newState !== oldState) {
            this.errorState = newState;
            this.stateChanges.next();
        }
    }
}
